import { IGuardPermissions } from '@portal/shared/auth/authorization/src';
import { PaymentsDashboardRouteName } from './payments-dashboard-route-name.enum';
import { UserRoles } from '@portal/shared/auth/authorization/src/lib/enums/user-roles.enum';

export const PaymentsDashboardRoutePermissions: {
  [key in PaymentsDashboardRouteName]?: IGuardPermissions;
} = {
  [PaymentsDashboardRouteName.home]: {
    read: [
      UserRoles.MerchantSupervisor,
      UserRoles.MerchantAdmin,
      UserRoles.MerchantUser,
      UserRoles.ProviderWhiteLabelManager,
      UserRoles.VerifoneAdmin,
      UserRoles.VerifoneUser,
    ],
  },
};
